<script setup>
import { ref,onMounted } from "vue";
import { useConfigStore} from "@/store/config"
import NavigationDataService from '@/services/NavigationDataService'
import NavIterator from '@/components/NavIterator'
import LocalizationDataService from "@/translations/LocalizationDataService";

const store = useConfigStore()
const slideType = ref(null)
const ancestors = ref(null)
const maxLevel = ref(2)
const parentItemId = ref({})
const navItem = ref({})
const navTree = ref(null)
const navLevel = ref(2)
const currentItemId = ref(null)
const curLocale = ref("fi")
const subsiteviewComponent = ref(null)
const mainTitle = ref(null)

const toggleChildren = (index) => {
  navTree.value[index].attributes.button.ariaExpanded = navTree.value[index].attributes.button.ariaExpanded === 'false' ? 'true' : 'false'
}

const closeSlideView = () => {
  store.setSlideViewActive(false)
}

onMounted(() => {
  // Set current locale
  curLocale.value = LocalizationDataService.getLocale()

  if (!!store.getSlideViewType) slideType.value = store.getSlideViewType
  if (store.getParents.length > 0) ancestors.value = store.getParents
  if (slideType.value === "topics" || slideType.value === "projects") maxLevel.value = 3
  if (!!store.getCurrentLayoutId) currentItemId.value = store.getCurrentLayoutId

  if (!!ancestors.value) {
    if (ancestors.value.length < maxLevel.value) {
      parentItemId.value = currentItemId.value
    } else {
      parentItemId.value = ancestors.value[ancestors.value.length - maxLevel.value]
    }
  } else {
    parentItemId.value = currentItemId.value
  }
  // If view is loaded by clicking right icon use store.getSlideLayoutId value
  if (!!store.getSlideLayoutId) parentItemId.value = store.getSlideLayoutId


  // If is topic get layoutID from store
  if (slideType.value === 'topic' && !!store.getSlideLayoutId) {
    parentItemId.value = store.getSlideLayoutId
  }

  // Projects
  // Check from ancestors which layout is used as parentItem
  if (slideType.value === 'projects' && !store.getSlideLayoutId) {
    if (ancestors.value.length < 3) {
      parentItemId.value = store.getCurrentLayoutId
    } else {
      parentItemId.value = ancestors.value[ancestors.value.length - 3]
    }
    store.setProjectPageLayoutId(parentItemId.value)
  }


  NavigationDataService.getChildren(parentItemId.value)
      .then((response) => {
        navItem.value = response.data
        Object.assign(navItem.value, { ariaCurrent : null })

        // Set nav item aria-current state
        if (navItem.value.navItemId === store.getCurrentLayoutId) navItem.value.ariaCurrent = "true"

        // Add locale prefix to url if locale other than FI
        if ( curLocale.value !== "fi")  navItem.value.friendlyUrl = `/${curLocale.value}${navItem.value.friendlyUrl}`

        if (navItem.value.children?.length > 0) {
          navTree.value = navItem.value.children
          navTree.value.forEach(nav => {
            const attrs = {
              li: {
                classes: "child-menu-item parent-menu-item"
              },
              button: {
                ariaExpanded: 'false'
              },
              ariaCurrent: null
            }

            Object.assign(nav, { attributes: attrs })

            // Add locale prefix to link urls
            if ( curLocale.value !== "fi") nav.friendlyUrl = `/${curLocale.value}${nav.friendlyUrl}`

            // Check if current page is active
            if (nav.navItemId === currentItemId.value ) {
              nav.attributes.li.classes  += " currentlast "
              nav.attributes.button.ariaExpanded = 'false'
              nav.attributes.ariaCurrent = "true"
            }

            // Check if current page is parent
            if (ancestors.value && ancestors.value.length > 0) {
              if (ancestors.value.includes(nav.navItemId)) {
                nav.attributes.li.classes += " currentpage open"
                nav.attributes.button.ariaExpanded = 'true'
              }
            }
          })
        }
      })
      .catch((e) => { console.log(e) })

      // Do animation
      setTimeout(() => {
       subsiteviewComponent.value.classList.add('isOpen')
     }, 100);

    // Set focus to correct element
    setTimeout(() => {
      if (mainTitle.value) mainTitle.value.focus()
    }, 1000)
})

</script>
<template>
  <li id="subsiteview" class="child-menu-item parent-sub" ref="subsiteviewComponent">
    <a
        :href="navItem.friendlyUrl"
        ref="mainTitle"
        :aria-current="navItem.ariaCurrent"
    ><span v-html="navItem.name"></span></a>
    <button class="right-icon open-new-navigation slide-toggler" @click="closeSlideView">
      <span class="sr-only">
        {{ LocalizationDataService.getText("back-main-nav")}}
      </span>
    </button>
    <ul class="child-menu" v-if="!!navTree">
      <li v-for="(navChild,index) in navTree" :key="navChild.navItemId" :data-nav-item="navChild.navItemId" :class="navChild.attributes.li.classes">
        <a
            :href="navChild.friendlyUrl"
            class="parent-menu-link-text has-btn"
            :aria-current="navChild.attributes.ariaCurrent"
        ><span v-html="navChild.name"></span></a>
        <template v-if="navChild.hasChildren">
          <button
              class="child-icon"
              :aria-expanded="navChild.attributes.button.ariaExpanded"
              @click="toggleChildren(index)"
          > <span class="sr-only">{{ navChild.name }} {{ LocalizationDataService.getText("section-sub-menu")}}</span></button>
          <NavIterator
              v-if="navChild.attributes.button.ariaExpanded === 'true'"
              :layout-id="navChild.navItemId"
              :level="navLevel + 1"
              :curLayoutId="parentItemId"
          />
        </template>
      </li>
    </ul>
  </li>
</template>